import axios from "@/util/axios";
import getCacheBuster from "@/util/getCacheBuster";

export const getSubstitutions = async (id) => {
  const response = await axios.get(`api/materials/substitutions`, {
    params: { material: id, _: getCacheBuster() },
  });
  return response.data;
};

export const checkSubstitutionsExists = async (id) => {
  const response = await axios.get(`api/materials/checkSubstitutionsExists`, {
    params: { material: id, _: getCacheBuster() },
  });
  return response.data;
};

/**
 * Fetch details for a materials list
 * @param {string[]} materials
 */
export const getDetailsBatch = async (materials) => {
  if (materials.length > 10) {
    const params = { materials: materials };
    const response = await axios.post(`api/materials/batch`, params);
    return response.data;
  } else {
    const params = { materials: materials, _: getCacheBuster() };
    const response = await axios.get(`api/materials/batch`, { params });
    return response.data;
  }
};

export const checkMaterialExists = async (material) => {
  const response = await axios.get(`api/materials/checkMaterialExists`, {
    params: { material, _: getCacheBuster() },
  });
  return response.data;
};

export const getTopSubstitutions = async (material) => {
  const response = await axios.get(`api/materials/topSubstitutions`, {
    params: { material, _: getCacheBuster() },
  });
  return response.data;
};
